module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersInStock":{"label":"Skladem"}},"de":{"CatalogFiltersInStock":{"label":"Auf Lager"}},"sk":{"CatalogFiltersInStock":{"label":"Na sklade"}}}')
  delete Component.options._Ctor
}
